import React from 'react';

const DesktopModalContainer = (props) => {
  const { children } = props;

  return (
    <div className="hidden lg:block">
      <div className="flex h-screen w-full items-center justify-center">
        <div
          className="relative flex min-h-[670px] w-[480px] flex-col rounded-lg"
          style={{
            boxShadow: 'rgba(0, 0, 0, 0.16) 0px 24px 48px',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default DesktopModalContainer;
